<template>
    <div class="modal-card pop_min" id="draggable" style="overflow-y:hidden">
        <header class="modal-card-head pop-header">
            <button class="icon is-right" @click="move" style="position:absolute;top:18px;right:70px;z-index:30;"><i class="fas fa-window-maximize" style="color:#fff;font-size:22px;padding-top:1px"></i></button>
            <p class="modal-card-title tit">
                {{ title }}
                <button class="btn-pop-close delete" aria-label="close" @click="$parent.close()"></button>
            </p>
        </header>
        <section class="modal-card-body pop-content">
        <div class="inner-box">
            <div class="table-b" style="margin-bottom: 10px">
                <div class="table-header">
                    <div class="table-name">
                        <h3 class="ico_table_name">상세정보 [<span style="color: #1e88cf">{{this.visitorNm}}</span>]</h3>
                    </div>
                </div>
                <div class="grid-wrap">
                    <dhx-grid ref="grid" v-model="carList" :config="config" @constructGridSuccessful="constructGridSuccessful"/>
                </div>
            </div>

        </div>
    </section>
    </div>
</template>

<script>
    import DhxGrid from '@/components/DhxGrid.vue'
    import _ from "lodash";

    export default {
        props: {
            visitNo: {
                type: String,
                required: false
            },
            visitorSeq: {
                type: Number,
                required: false
            },
            visitorNm: {
                type: String,
                required: false
            },
        },
        components: {DhxGrid},
        data() {
            return {
                config : {
                    columns: [
                        {id: 'no', type: 'cntr', align: 'center',value: 'No.',width: 35},
                        {id: 'purposeNm',align: 'center',value: '차량출입목적',width: 50},
                        {id: 'carCategoryNm',align: 'center',value: '차량구분',width: 80},
                        {id: 'carNm',align: 'center',value: '차량명',width: 100},
                        {id: 'carNumber',align: 'center',value: '차량번호',width: 100},
                    ],
                    height: 240,
                    enablePaging: false,
                    afterRefreshData(grid, data) {
                        this.$nextTick(() => {
                            _.forEach(data, (item, index) => {
                                let rId = index + 1
                            })
                        })
                    }
                },
                title: '차량정보',
                carList: [],
                loaded: false,
                isNew: false,
                isMxMn: true
            }
        },
        methods: {
            constructGridSuccessful(grid) {
            },
            getCarInfo(visitNo, visitorSeq) {
                this.$http.get(`/api/visit/visitorCarInfo`, {params: {visitNo: visitNo, visitorSeq: visitorSeq}})
                    .then(response => {
                        this.carList = response.data;
                    })
                    .catch(({message}) => {
                        console.error(message);
                    })
            },
            move() {
                if(this.isMxMn) {
                    $(".modal-card").removeClass('pop_min')
                    $(".modal-card").addClass('pop_max');

                    $(".animation-content").removeClass('pop_min')
                    $(".animation-content").addClass('pop_max');
                    this.isMxMn = false
                } else {
                    $(".modal-card").removeClass('pop_max')
                    $(".modal-card").addClass('pop_min');

                    $(".animation-content").removeClass('pop_max')
                    $(".animation-content").addClass('pop_min');
                    this.isMxMn = true
                }
            },
        },
        created() {
        },
        mounted() {
            //pop slots modal move
            $(".animation-content").addClass('pop_min');
            $(".animation-content").draggable();
            //ModalSlot open z-index change
            $('.lnb').css('z-index', '4');
            this.getCarInfo(this.visitNo, this.visitorSeq)
        },
        destroyed() {
            //ModalSlot open z-index change
            $('.lnb').css('z-index', '7');
        },
    }
</script>

<style scoped>
    .modal-card {
        width: auto;
    }
</style>
